import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export interface CreditTransaction {
  id: string;
  organization_id: string;
  type: 'topup' | 'reserve' | 'usage' | 'settle' | 'adjustment' | 'refund';
  amount: number;
  running_balance: number;
  description: string | null;
  reference_id: string | null;
  metadata: Record<string, unknown>;
  created_at: string;
}

class CreditsService {
  async getBalance(): Promise<{ balance: number; currency: string }> {
    const response = await apiClient.get<ApiResponse<{ balance: number; currency: string }>>('/credits/balance');
    return response.data.data || { balance: 0, currency: 'USD' };
  }

  async getTransactions(limit = 50, offset = 0): Promise<{ transactions: CreditTransaction[]; total: number }> {
    const response = await apiClient.get<ApiResponse<{ transactions: CreditTransaction[]; total: number }>>(
      `/credits/transactions?limit=${limit}&offset=${offset}`
    );
    return response.data.data || { transactions: [], total: 0 };
  }

  async topUp(amount: number, description?: string): Promise<{ transaction: CreditTransaction; balance: number }> {
    const response = await apiClient.post<ApiResponse<{ transaction: CreditTransaction; balance: number }>>(
      '/credits/topup',
      { amount, description }
    );
    if (response.data.data) return response.data.data;
    throw new Error('Failed to add credits');
  }
}

export const creditsService = new CreditsService();
